var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"licence__list_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'createdAt',
                title: 'Created on',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'courseName',
                title: 'Course name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'customer',
                title: 'Customer',
                type: 'string'
            },
            {
                key: 'numberOfLicences',
                title: 'Total',
                type: 'number',
                sortable: true,
                queryable: true
            },
            {
                key: 'left',
                title: 'Left',
                type: 'number'
            },
            {
                key: 'used',
                title: 'Used',
                type: 'number'
            },
            {
                key: 'validFromDate',
                title: 'Start date',
                type: 'date',
                sortable: true,
                queryable: true
            },
            {
                key: 'validToDate',
                title: 'Expiry date',
                type: 'date',
                sortable: true,
                queryable: true
            },
            {
                key: 'status',
                title: 'Status',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'actions',
                title: '',
                type: 'string'
            }
        ],"items":_vm.items,"component-table-item":_vm.LicenceListTableItem,"sort-queryable":_vm.sortQueryable},on:{"emit-sort":_vm.handleSort,"emit-suspend":_vm.openNotifySuspendLicence,"emit-restore":_vm.openNotifyRestoreLicence,"emit-archive":_vm.openNotifyArchiveLicence}}),_c('pop-notify',{ref:"notifysuspendoffer",class:'pop__notify--suspend',attrs:{"title-text":'Suspend offer?',"content-text":'Suspending this offer will prevent the organisation from accessing this course.\n Please give a reason for why you are suspending the offer.',"cancel-button-text":'Cancel',"submit-button-text":'Ok',"submit-button-animate-loading":true,"prevent-close":true,"size":'medium'},on:{"emit-submit":_vm.performSuspendLicence}},[_c('form-editor',{attrs:{"name":'licence-list-table-notify-note-suspend'},model:{value:(_vm.licenceDescription),callback:function ($$v) {_vm.licenceDescription=$$v},expression:"licenceDescription"}})],1),_c('pop-notify',{ref:"notifyrestoreoffer",class:'pop__notify--restore',attrs:{"title-text":'Restore offer?',"content-text":'Restoring this offer will give the organisation access to this course again.\n Please give a reason for why you are restoring the offer.',"cancel-button-text":'Cancel',"submit-button-text":'Ok',"submit-button-animate-loading":true,"prevent-close":true,"size":'medium'},on:{"emit-submit":_vm.performRestoreLicence}},[_c('form-editor',{attrs:{"name":'licence-list-table-notify-note-restore'},model:{value:(_vm.licenceDescription),callback:function ($$v) {_vm.licenceDescription=$$v},expression:"licenceDescription"}})],1),_c('pop-notify',{ref:"notifyarchiveoffer",class:'pop__notify--archive',attrs:{"title-text":'Archive offer?',"content-text":'Archiving this offer will revoke the customers access to the course. \n\n You will not be able to restore the offer once it has been archived. \n\n The offer will still be visible to you in your licence table. \n\n Would you like to archive this offer?',"cancel-button-text":'Cancel',"submit-button-text":'Yes',"submit-button-danger":true,"submit-button-animate-loading":true,"prevent-close":true},on:{"emit-submit":_vm.performArchiveLicence}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }